import sw from './sw/index.js';
import en from './en/index.js';

export const messages = {
  ru: {
    invoice_flow__selcom_ussd_push_message: 'Пожалуйста, завершите оплату при помощи телефона!',
  },

  uk: {
    invoice_flow__selcom_ussd_push_message: 'Будь ласка, завершіть оплату за допомогою телефону!',
  },

  en,
  sw,
};
